import React from 'react'

const SvgPostingService = props => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="currentColor" {...props}>
    <path d="M20 15h-8a2 2 0 00-2 2v4a2 2 0 002 2h1v4a1 1 0 001 1h2a1 1 0 001-1v-4h3l5 4V11l-5 4zm3 7.6L21 21h-9v-4h9l2-1.6v7.2zm6.5-3.6c0 1.71-.96 3.26-2.5 4v-8c1.53.75 2.5 2.3 2.5 4z" />
  </svg>
)

export default SvgPostingService
